import Axios from "./axios";

const resource = "merchants";

export default {
  get() {
		return Axios.get(`${resource}`);
	},
	getViaSlug(slug, payload) {
		return Axios.get(`${resource}/show/${slug}`, payload);
	}
}